/** The board's word for a transaction's kind. The type column and the PDF (HAT-1399) both print it. */
export function transactionTypeText(kind: string, t: (key: string) => string): string {
  switch (kind) {
    case 'תרומה':
      return t('donationType');
    case 'תשלום ספקים':
    case 'תשלום ספקים (הוראת קבע)':
      return t('paymentType');
    case 'תמיכה':
    case 'מלגה':
      return t('supportType');
    default:
      return kind;
  }
}
